import { render, staticRenderFns } from "./validation-table.vue?vue&type=template&id=355211db&scoped=true"
import script from "./validation-table.vue?vue&type=script&lang=js"
export * from "./validation-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355211db",
  null
  
)

export default component.exports